export default "__VITE_ASSET__B4oTZ4go__"